import { ROUTES } from "@/constants/routes";
import { useTranslation } from "react-i18next";

interface NavigationLink {
  label: string;
  href: string;
  icon: string;
}

export function useSideNavigationLinks(): Array<NavigationLink> {
  const { t } = useTranslation();

  return [
    {
      label: t("navigation_links.stats"),
      href: ROUTES.DASHBOARD,
      icon: "dashboardIcon",
    },
    {
      label: t("navigation_links.dilemmas"),
      href: ROUTES.DILEMMAS,
      icon: "dilemmaIcon",
    },
    {
      label: t("navigation_links.submissions"),
      href: ROUTES.SUBMISSIONS,
      icon: "submissionsIcon",
    },
    {
      label: t("navigation_links.themes"),
      href: ROUTES.THEMES,
      icon: "themesIcon",
    },
    {
      label: t("navigation_links.users"),
      href: ROUTES.USERS,
      icon: "usersIcon",
    },
    {
      label: t("navigation_links.documentation"),
      href: ROUTES.DOCUMENTATION,
      icon: "docIcon",
    },
    {
      label: t("navigation_links.warning"),
      href: ROUTES.WARNINGS,
      icon: "warningIcon",
    },
    {
      label: t("navigation_links.history"),
      href: ROUTES.HISTORY,
      icon: "historyIcon",
    },
    {
      label: t("navigation_links.informations"),
      href: ROUTES.ABOUT,
      icon: "informationsIcon",
    },
  ];
}
